import revive_payload_client_4sVQNw7RlN from "/tmp/8dda472cd6067b3/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/tmp/8dda472cd6067b3/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/tmp/8dda472cd6067b3/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import _0_siteConfig_7pzUtwM1Zj from "/tmp/8dda472cd6067b3/node_modules/nuxt-site-config/dist/runtime/nuxt/plugins/0.siteConfig.mjs";
import payload_client_yVLowv6hDl from "/tmp/8dda472cd6067b3/node_modules/nuxt/dist/app/plugins/payload.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/tmp/8dda472cd6067b3/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import plugin_vue3_A0OWXRrUgq from "/tmp/8dda472cd6067b3/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/tmp/8dda472cd6067b3/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/tmp/8dda472cd6067b3/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_client_LcKgStRyi6 from "/tmp/8dda472cd6067b3/node_modules/nuxt-gtag/dist/runtime/plugin.client.mjs";
import plugin_HQNyLQlVwt from "/tmp/8dda472cd6067b3/node_modules/nuxt3-meta-pixel/dist/runtime/plugin.mjs";
import plugin_8SbxDRbG6Y from "/tmp/8dda472cd6067b3/node_modules/dayjs-nuxt/dist/runtime/plugin.mjs";
import plugin_AOuQ1DYzjk from "/tmp/8dda472cd6067b3/node_modules/@sidebase/nuxt-auth/dist/runtime/plugin.mjs";
import i18n_yfWm7jX06p from "/tmp/8dda472cd6067b3/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.mjs";
import plugin_t2GMTTFnMT from "/tmp/8dda472cd6067b3/node_modules/@nuxtjs/device/dist/runtime/plugin.mjs";
import chunk_reload_client_UciE0i6zes from "/tmp/8dda472cd6067b3/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_1UohGbtF8v from "/tmp/8dda472cd6067b3/node_modules/@pinia-plugin-persistedstate/nuxt/dist/runtime/plugin.mjs";
import index_NoOeBbAe38 from "/tmp/8dda472cd6067b3/plugins/vuetify/index.js";
import index_HYtSsfhyFh from "/tmp/8dda472cd6067b3/plugins/iconify/index.js";
import error_listener_client_hRRGZJXxzD from "/tmp/8dda472cd6067b3/plugins/error-listener.client.ts";
import filters_VNgPjx6zHj from "/tmp/8dda472cd6067b3/plugins/filters.ts";
import layouts_OBoGUkHiof from "/tmp/8dda472cd6067b3/plugins/layouts.js";
import maska_UHaKf2z1iQ from "/tmp/8dda472cd6067b3/plugins/maska.ts";
import particles_fbwFXWtyue from "/tmp/8dda472cd6067b3/plugins/particles.js";
import vue_diff_7CFe2d2sU5 from "/tmp/8dda472cd6067b3/plugins/vue-diff.js";
import vue_draggable_client_OlAgW8lMLf from "/tmp/8dda472cd6067b3/plugins/vue-draggable.client.js";
import vue_flow_client_VCaq7w5mCS from "/tmp/8dda472cd6067b3/plugins/vue-flow.client.js";
import vue_gantt_cUaRWYJKgP from "/tmp/8dda472cd6067b3/plugins/vue-gantt.js";
import webfontloader_client_Jql8Gs55fp from "/tmp/8dda472cd6067b3/plugins/webfontloader.client.js";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  _0_siteConfig_7pzUtwM1Zj,
  payload_client_yVLowv6hDl,
  check_outdated_build_client_8vK7RkfGxZ,
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_client_LcKgStRyi6,
  plugin_HQNyLQlVwt,
  plugin_8SbxDRbG6Y,
  plugin_AOuQ1DYzjk,
  i18n_yfWm7jX06p,
  plugin_t2GMTTFnMT,
  chunk_reload_client_UciE0i6zes,
  plugin_1UohGbtF8v,
  index_NoOeBbAe38,
  index_HYtSsfhyFh,
  error_listener_client_hRRGZJXxzD,
  filters_VNgPjx6zHj,
  layouts_OBoGUkHiof,
  maska_UHaKf2z1iQ,
  particles_fbwFXWtyue,
  vue_diff_7CFe2d2sU5,
  vue_draggable_client_OlAgW8lMLf,
  vue_flow_client_VCaq7w5mCS,
  vue_gantt_cUaRWYJKgP,
  webfontloader_client_Jql8Gs55fp
]